import GradientBlock from 'components/GradientBlock';
import MainTabs from 'components/main-components/MainTabs';
import { PrivaciesTabs } from 'consts/tabs';
import React from 'react'
import { Outlet } from 'react-router-dom';

const PrivaciesRoute = () => {
  return (
    <>
      <GradientBlock additionalClassName='gradient-block--green'>
        <MainTabs tabs={PrivaciesTabs} />
      </GradientBlock>
      <Outlet />
    </>
  )
}

export default PrivaciesRoute;
